"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncSegmentSearchDocuments = exports.replaceSegmentSearchDocuments = exports.syncScriptSearchDocument = void 0;
__exportStar(require("common/function-client"), exports);
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const functions_1 = require("firebase/functions");
const functions = (0, functions_1.getFunctions)(firebase_app_1.default, "asia-northeast1");
exports.syncScriptSearchDocument = (0, functions_1.httpsCallable)(functions, "syncScriptSearchDocument");
exports.replaceSegmentSearchDocuments = (0, functions_1.httpsCallable)(functions, "replaceSegmentSearchDocuments");
exports.syncSegmentSearchDocuments = (0, functions_1.httpsCallable)(functions, "syncSegmentSearchDocuments");
